<template>
  <el-dialog
    :visible="visible"
    @update:visible="(v) => $emit('update:visible', v)"
    :show-close="true"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    @close="onCancel"
  >
    <div slot="title" style="display:flex;align-items:center;gap:12px;">
      <span style="display:inline-block;width:3px;height:18px;background:#7367F0;border-radius:2px;"></span>
      <span style="font-weight:700;letter-spacing:-0.2px;">{{ title }}</span>
    </div>

    <div style="display:flex;flex-direction:column;gap:18px;">
      <div v-if="$slots.subject"
        style="padding:14px 16px;border:1px solid rgba(115,103,240,0.2);background:rgba(115,103,240,0.04);border-radius:6px;font-size:13px;line-height:1.5;">
        <slot name="subject"></slot>
      </div>

      <div v-if="$slots.diff">
        <label style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin-bottom:6px;">변경 내용</label>
        <div style="background:rgba(0,0,0,0.04);border:1px solid rgba(0,0,0,0.08);border-radius:6px;padding:12px 14px;font-family:ui-monospace,'SF Mono',Menlo,Consolas,monospace;font-size:12px;line-height:1.6;">
          <slot name="diff"></slot>
        </div>
      </div>

      <div>
        <label style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin-bottom:6px;">사유 <span style="opacity:0.5;text-transform:none;letter-spacing:0;font-weight:500;">(필수, 5자 이상)</span></label>
        <el-input
          v-model="reason"
          type="textarea"
          :rows="2"
          placeholder="변경 사유를 입력하세요"
          :maxlength="500"
          show-word-limit
        ></el-input>
      </div>

      <div>
        <label style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin-bottom:6px;">
          확인 토큰
          <code style="background:rgba(115,103,240,0.1);color:#7367F0;padding:1px 6px;border-radius:3px;font-family:ui-monospace,'SF Mono',Menlo,Consolas,monospace;font-size:11px;margin-left:6px;text-transform:none;letter-spacing:0;">{{ confirmToken }}</code>
        </label>
        <el-input v-model="typed" placeholder="확인을 위해 위 값을 입력하세요" autocomplete="off" size="medium"></el-input>
      </div>
    </div>

    <span slot="footer" style="display:flex;justify-content:flex-end;gap:8px;">
      <el-button size="small" @click="onCancel">취소</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="submitting"
        :disabled="!ready"
        @click="onConfirm"
        :style="dangerous ? 'background:#EA5455;border-color:#EA5455;' : 'background:#7367F0;border-color:#7367F0;'"
      >
        {{ confirmLabel }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  name: 'ConfirmActionDialog',
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, required: true },
    confirmToken: { type: String, required: true },
    confirmLabel: { type: String, default: '확인' },
    dangerous: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dialogWidth: { type: String, default: '560px' },
  },
  data() {
    return { reason: '', typed: '' }
  },
  computed: {
    ready() {
      return (
        !this.submitting &&
        !this.disabled &&
        this.reason.trim().length >= 5 &&
        this.typed.trim() === this.confirmToken
      )
    },
  },
  watch: {
    visible(v) {
      if (!v) {
        this.reason = ''
        this.typed = ''
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    onConfirm() {
      if (!this.ready) return
      this.$emit('confirm', { reason: this.reason.trim() })
    },
  },
}
</script>
